(() => {
  const root = document.querySelector('[data-jsk-assistant]');
  if (!root) return;

  const panel = root.querySelector('[data-jsk-assistant-panel]');
  const openButton = root.querySelector('[data-jsk-assistant-open]');
  const closeButton = root.querySelector('[data-jsk-assistant-close]');
  const form = root.querySelector('[data-jsk-assistant-form]');
  const input = root.querySelector('[data-jsk-assistant-input]');
  const messages = root.querySelector('[data-jsk-assistant-messages]');
  const quickActions = root.querySelectorAll('[data-jsk-assistant-query]');
  const catalogMode = root.dataset.catalogMode === 'true';
  const dedicatedProductPages = root.dataset.dedicatedProductPages === 'true';
  let clothing = [];
  let loadingPromise;

  const fixedProducts = [
    { title: 'SU8 City Adventure', code: 'JSK-SU8-48V16', category: 'E-bikes', type: 'Available now', description: '1000W city configuration with a 48V 16Ah battery and Black or Orange options.', url: '/products/su8-city-adventure', reviewUrl: '/collections/e-bikes?product=JSK-SU8-48V16' },
    { title: 'SU8 Long Range', code: 'JSK-SU8-48V20', category: 'E-bikes', type: 'Available now', description: '1500W long-range configuration with a 48V 20Ah battery and hydraulic disc brakes.', url: '/products/su8-long-range', reviewUrl: '/collections/e-bikes?product=JSK-SU8-48V20' },
    { title: 'R700 Trail 25', code: 'JSK-R700-48V25', category: 'E-bikes', type: 'Available now', description: '2000W system, 48V 25Ah battery, hydraulic disc brakes and fat tires.', url: '/products/r700-trail-25', reviewUrl: '/collections/e-bikes?product=JSK-R700-48V25' },
    { title: 'R700 Trail 30', code: 'JSK-R700-52V30', category: 'E-bikes', type: 'Available now', description: '1500W motor, 52V 30Ah battery and hydraulic disc brakes.', url: '/products/r700-trail-30', reviewUrl: '/collections/e-bikes?product=JSK-R700-52V30' },
    { title: 'R700-PRO Performance', code: 'JSK-R700PRO-60V30', category: 'E-bikes', type: 'Available now', description: '2000W system, 60V 30Ah battery and hydraulic disc brakes.', url: '/products/r700-pro-performance', reviewUrl: '/collections/e-bikes?product=JSK-R700PRO-60V30' },
    { title: 'F1 AWD Dual Motor', code: 'JSK-F1-48V25', category: 'E-bikes', type: 'Available now', description: '2000W AWD configuration with a 48V 25Ah battery and hydraulic disc brakes.', url: '/products/f1-awd-dual-motor', reviewUrl: '/collections/e-bikes?product=JSK-F1-48V25' },
    { title: 'Fabric-Covered Female Torso Dress Form', code: 'JSK-FGD-4', category: 'Mannequins', type: 'Coming soon', description: 'Adjustable boutique display form for styling, fitting and photography.', url: '/products/fabric-covered-female-torso-dress-form', reviewUrl: '/collections/mannequins?product=JSK-FGD-4' },
    { title: 'Curvy Full-Body Female Mannequin', code: 'JSK-PD-1', category: 'Mannequins', type: 'Coming soon', description: 'Full-body display mannequin with a neutral stance and stable base.', url: '/products/curvy-full-body-female-mannequin', reviewUrl: '/collections/mannequins?product=JSK-PD-1' },
    { title: 'Curvy Female Lower-Body Mannequin', code: 'JSK-PD-5', category: 'Mannequins', type: 'Coming soon', description: 'Waist-down display form for skirts, shorts, hosiery and fitted garments.', url: '/products/curvy-female-lower-body-mannequin', reviewUrl: '/collections/mannequins?product=JSK-PD-5' },
    { title: 'Headless and Armless Female Mannequin', code: 'JSK-PD-12', category: 'Mannequins', type: 'Coming soon', description: 'Streamlined display form designed for quick garment changes.', url: '/products/headless-and-armless-female-mannequin', reviewUrl: '/collections/mannequins?product=JSK-PD-12' },
    { title: 'Headless Female Mannequin with Arms', code: 'JSK-PD-13', category: 'Mannequins', type: 'Coming soon', description: 'Full-body display form for dresses, tops, jackets and layered looks.', url: '/products/headless-female-mannequin-with-arms', reviewUrl: '/collections/mannequins?product=JSK-PD-13' }
  ];

  const departmentResults = {
    clothing: { title: 'Clothing', code: 'Women · Men · Kids', type: 'Department', url: '/collections/apparel' },
    home: { title: 'Home & Sleep', code: 'Comfort essentials', type: 'Coming soon', url: '/collections/home-sleep' },
    auto: { title: 'Auto Parts', code: 'Vehicle essentials', type: 'Coming soon', url: '/collections/auto-parts' },
    ebikes: { title: 'E-bikes', code: 'Available R700 and F1 models', type: 'Department', url: '/collections/e-bikes' },
    mannequins: { title: 'Mannequins', code: 'Boutique display forms', type: 'Coming soon', url: '/collections/mannequins' }
  };

  const stopWords = new Set(['a','an','and','are','can','do','find','for','get','i','in','is','looking','me','my','of','please','show','some','the','to','want','what','with']);
  const normalize = (value = '') => value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const tokensFor = (value) => normalize(value).split(/\s+/).filter((token) => token.length > 1 && !stopWords.has(token));

  const loadCatalog = () => {
    if (loadingPromise) return loadingPromise;
    loadingPromise = fetch(root.dataset.catalogUrl, { credentials: 'same-origin' })
      .then((response) => response.ok ? response.json() : Promise.reject(new Error('catalog unavailable')))
      .then((data) => {
        clothing = Array.isArray(data.items) ? data.items.map((item) => ({
          ...item,
          url: item.handle ? `/products/${encodeURIComponent(item.handle)}` : `/collections/apparel?product=${encodeURIComponent(item.code)}`,
          reviewUrl: `/collections/apparel?product=${encodeURIComponent(item.code)}`,
          type: item.type || item.category || 'Clothing'
        })) : [];
      })
      .catch(() => { clothing = []; });
    return loadingPromise;
  };

  const addMessage = (text, kind = 'assistant', results = []) => {
    const wrapper = document.createElement('div');
    wrapper.className = `jsk-assistant__message is-${kind}`;
    const copy = document.createElement('p');
    copy.textContent = text;
    wrapper.appendChild(copy);

    if (results.length) {
      const list = document.createElement('div');
      list.className = 'jsk-assistant__results';
      results.slice(0, 4).forEach((item) => {
        const link = document.createElement('a');
        link.className = 'jsk-assistant__result';
        link.href = catalogMode && !dedicatedProductPages && item.reviewUrl ? item.reviewUrl : item.url;
        const detail = document.createElement('span');
        const title = document.createElement('strong');
        const code = document.createElement('small');
        const state = document.createElement('b');
        title.textContent = item.title;
        code.textContent = item.code;
        state.textContent = item.type || 'View';
        detail.append(title, code);
        link.append(detail, state);
        list.appendChild(link);
      });
      wrapper.appendChild(list);
    }

    messages.appendChild(wrapper);
    messages.scrollTop = messages.scrollHeight;
  };

  const scoreProduct = (product, tokens, query) => {
    const code = normalize(product.code);
    const title = normalize(product.title);
    const category = normalize(product.category);
    const type = normalize(product.type);
    const description = normalize(product.description);
    let score = 0;
    if (code && normalize(query).includes(code)) score += 100;
    tokens.forEach((token) => {
      if (code.includes(token)) score += 20;
      if (title.includes(token)) score += 8;
      if (type.includes(token)) score += 6;
      if (category.includes(token)) score += 5;
      if (description.includes(token)) score += 1;
    });
    return score;
  };

  const searchProducts = (query) => {
    const tokens = tokensFor(query);
    return [...fixedProducts, ...clothing]
      .map((item) => ({ item, score: scoreProduct(item, tokens, query) }))
      .filter(({ score }) => score > 0)
      .sort((a, b) => b.score - a.score || a.item.title.localeCompare(b.item.title))
      .map(({ item }) => item);
  };

  const respond = async (rawQuery) => {
    const query = rawQuery.trim().slice(0, 160);
    if (!query) return;
    addMessage(query, 'user');
    await loadCatalog();

    const normalized = normalize(query);
    const has = (...terms) => terms.some((term) => normalized.includes(term));

    if (has('shipping','delivery','deliver')) {
      addMessage('Delivery options and timing depend on the product and destination. Review the current guidance, then use the product’s JSK Code when requesting an order update.', 'assistant', [{ title: 'Shipping & Delivery', code: 'Delivery guidance', type: 'Help', url: '/pages/shipping' }]);
      return;
    }
    if (has('return','refund','warranty')) {
      addMessage('Returns, delivery-damage steps and warranty guidance are explained on the policy page. Final terms are confirmed with the exact product and order.', 'assistant', [{ title: 'Returns, Refunds & Warranty', code: 'Customer guidance', type: 'Help', url: '/pages/returns-refunds' }]);
      return;
    }
    if (has('payment','checkout','pay')) {
      addMessage('Secure checkout and payment guidance is available here. Coming Soon interest registration does not charge you.', 'assistant', [{ title: 'Payments & Checkout', code: 'Secure order guidance', type: 'Help', url: '/pages/payments' }]);
      return;
    }
    if (has('contact','human','support','help me')) {
      addMessage('You can contact JSK Marketplace for product, availability or order help. Include the JSK Code when possible so the team can identify the exact item.', 'assistant', [{ title: 'Contact JSK Marketplace', code: 'Product and order help', type: 'Support', url: '/pages/contact' }]);
      return;
    }
    if (has('coming soon','preorder','pre order','interest','register')) {
      addMessage('Coming Soon products are previews. You can register interest without paying; JSK will use the product’s code to keep your request matched to the correct item.', 'assistant', [{ title: 'Coming Soon', code: 'Private interest registration', type: 'Learn more', url: '/pages/coming-soon' }]);
      return;
    }
    if (has('price','cost','discount','deal')) {
      addMessage('Most upcoming products do not show prices yet. Available e-bike ordering details and any approved offers are confirmed on the exact product path before payment.', 'assistant', [departmentResults.ebikes, { title: 'Contact for an ordering update', code: 'Use the product JSK Code', type: 'Support', url: '/pages/contact' }]);
      return;
    }
    if (has('home','sleep','mattress','bed','sofa')) {
      addMessage('Home & Sleep is being prepared as a Coming Soon department. You can preview the department and register interest as products are added.', 'assistant', [departmentResults.home]);
      return;
    }
    if (has('auto','car part','vehicle','brake pad','suspension')) {
      addMessage('Auto Parts is a Coming Soon department for vehicle maintenance and replacement essentials.', 'assistant', [departmentResults.auto]);
      return;
    }

    const results = searchProducts(query);
    if (results.length) {
      const exactCode = results[0] && normalize(query).includes(normalize(results[0].code));
      addMessage(exactCode ? 'I found the exact JSK Code.' : `I found ${results.length} possible match${results.length === 1 ? '' : 'es'}. Here are the closest options:`, 'assistant', results);
      return;
    }

    addMessage('I could not find an exact product match yet. Try a simpler phrase such as “men’s polo shirts,” “kids dresses,” “e-bikes,” or enter the full JSK Code.', 'assistant', [departmentResults.clothing, departmentResults.ebikes, departmentResults.mannequins]);
  };

  const open = () => {
    root.classList.add('is-open');
    panel.hidden = false;
    openButton.setAttribute('aria-expanded', 'true');
    loadCatalog();
    window.setTimeout(() => input.focus(), 40);
  };
  const close = () => {
    root.classList.remove('is-open');
    panel.hidden = true;
    openButton.setAttribute('aria-expanded', 'false');
    openButton.focus();
  };

  openButton.addEventListener('click', open);
  closeButton.addEventListener('click', close);
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const query = input.value;
    input.value = '';
    respond(query);
  });
  quickActions.forEach((button) => button.addEventListener('click', () => respond(button.dataset.jskAssistantQuery || '')));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) close();
  });
})();
